import { get, useFormContext } from 'react-hook-form';
import SingleSelectInput from '@/components/form/SingleSelectInput.tsx';
import TwoInputsRow from '@/components/form/ui/TwoInputsRow.tsx';
import { TransportInputForm } from '@/features/dashboard/tourTransport/schemas/transportSchema.ts';
import { UfgTransportType } from '@/features/dashboard/tfg/types/UfgTransportType.ts';
import {
  isFlightType,
  ufgTransportTypeSelectOptions,
} from '@/features/dashboard/tfg/types/UfgTransportType.utils.ts';
import AirportSelectInput from '@/features/dashboard/tfg/components/AirportSelectInput.tsx';

const TfgVariantTypingFields = ({ index }: { index: number }) => {
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<TransportInputForm>();

  const ufgTransportType = watch(`variants.${index}.ufgTransportType`);

  // Airport is only valid for flight types — clear it when switching away.
  const handleTypeChange = (value: string | object | undefined) => {
    if (!isFlightType(value as UfgTransportType)) {
      setValue(`variants.${index}.airportCode`, undefined);
    }
  };

  const typeSelect = (
    <SingleSelectInput
      fieldName={`variants.${index}.ufgTransportType`}
      label="Typ transportu (UFG)"
      placeholder="Wybierz typ transportu"
      required
      control={control}
      options={ufgTransportTypeSelectOptions}
      onChange={handleTypeChange}
      error={get(errors, `variants.${index}.ufgTransportType.message`)}
    />
  );

  if (!isFlightType(ufgTransportType)) {
    return typeSelect;
  }

  return (
    <TwoInputsRow ratio="1/1">
      {typeSelect}
      <AirportSelectInput index={index} />
    </TwoInputsRow>
  );
};

export default TfgVariantTypingFields;
